/**
 * @file Album Transactions filter actions.
 */

export const UPDATE_FILTER = 'album-transactions-filter/UPDATE_FILTER';
export const RESET_FILTER = 'album-transactions-filter/RESET_FILTER';

export const updateFilter = filter => {
  return { type: UPDATE_FILTER, filter };
};

export const resetFilter = () => {
  return { type: RESET_FILTER };
};
